module.exports = __webpack_public_path__ + "static/media/urgentAction.92bcc34b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/urgentAction.svg
// module id = 227
// module chunks = 0